import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { ToastContainer } from 'react-toastify';

import { useNavigation } from '../../../common/navigation';

export const UserStampsLink = (props: { userId: string }) => {
  const nav = useNavigation();

  const handleClick = () => {
    nav.stampsEdit(props.userId);
  };

  return (
    <>
      <ToastContainer />
      <OverlayTrigger
        overlay={
          <Tooltip style={{ position: 'fixed' }}>
            Edycja pieczątek i podpisu użytkownika
          </Tooltip>
        }
      >
        <Button
          onClick={e => {
            e.stopPropagation();
            handleClick();
          }}
          variant="btn-info"
        >
          <Icon.PersonBadge />
        </Button>
      </OverlayTrigger>
    </>
  );
};
